<nav class="nav-tabla">
    <ul>
      <li routerLinkActive="activo">
        <a [routerLink]="['/contratista/docpropia']">Documentación Propia</a>
      </li>
      <li routerLinkActive="activo" *ngIf="!xtensaBasica">
        <a [routerLink]="['/contratista/estado/instalaciones']">Instalaciones</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/contratista/estado/clientes']">Clientes</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/contratista/estado/centros']">Centros</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/contratista/estado/gestores']">Gestores</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/contratista/estado/transportistas']">Transportistas</a>
      </li>
    </ul>
  </nav>
